module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-content-tab"
  }, [_c('el-tabs', _vm._b({
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  }, 'el-tabs', _vm.$attrs, false), _vm._l((_vm.tabList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item.label,
        "name": item.name
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ca64488"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/tab/rtContentTabs.vue
// module id = 1418
// module chunks = 116